import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Chip,
  Divider,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { FaBath } from "react-icons/fa";
import { GiBed } from "react-icons/gi";
import { LuLandPlot } from "react-icons/lu";
import { FaLocationDot } from "react-icons/fa6";
import { MdAddCall, MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";

// Styled components
const PropertyCard = styled(Card)(({ theme }) => ({
  width: "100%",
  borderRadius: "12px",
  overflow: "hidden",
  transition: "transform 0.3s, box-shadow 0.3s",
  position: "relative",
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: theme.shadows[10],
    "& .hoverActions": {
      opacity: 1,
    },
  },
}));

const ImageContainer = styled(Box)({
  position: "relative",
  overflow: "hidden",
  height: 220,
});

const PriceTag = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 20,
  left: 0,
  backgroundColor: "#C10E14",
  color: "white",
  padding: "6px 15px",
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
  fontWeight: "bold",
  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  zIndex: 2,
}));

const PropertyType = styled(Chip)(({ theme }) => ({
  position: "absolute",
  top: 20,
  right: 15,
  fontWeight: "bold",
  backgroundColor: "white",
  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  zIndex: 2,
}));

const FeatureBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  backgroundColor: theme.palette.grey[50],
  padding: "4px 10px",
  borderRadius: "4px",
  fontSize: "14px",
}));

const ContactButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  padding: "8px 16px",
  fontWeight: "bold",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    boxShadow: theme.shadows[2],
  },
}));

const CardComponent = ({ pageType, data }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
        gap: "30px",
        padding: "20px",
      }}
    >
      {data?.map((item, index) => (
        <PropertyCard
          key={index}
          elevation={3}
          onClick={
            () => navigate(`/properties/${item?.slug}?page=${item?.category}`)

            // navigate(ROUTES.PROPERTIES(item?.slug), {
            //   state: { page: item?.category },
            // })
          }
        >
          <ImageContainer>
            <PriceTag>
              {pageType === "offplan"
                ? `Starting from ${item.price} `
                : `${item.price}`}
              AED
            </PriceTag>
            <PropertyType
              label={item?.type}
              // color={item.type === "Apartment" ? "primary" : "secondary"}
              color="black"
              size="small"
            />
            <CardMedia
              component="img"
              image={item.thumbnail}
              alt="Property Images"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transition: "transform 0.5s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
          </ImageContainer>

          <CardContent sx={{ padding: "20px" }}>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "12px",
                lineHeight: 1.3,
                minHeight: "42px",
                height: "auto",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {item?.title}
            </Typography>
            {/* <Typography
              variant="subtitle1"
              component="div"
              sx={{ 
                fontSize: "20px", 
                fontWeight: "600", 
                marginBottom: "12px",
                lineHeight: 1.3,
                height: "42px",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical"
              }}
            >
              {Array.isArray(item.facilities) ? item.facilities.join(" | ") : ""}
            </Typography> */}

            <Box
              sx={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
                mb: 2,
              }}
            >
              <FeatureBox>
                <GiBed style={{ fontSize: "18px" }} /> {item?.room}
              </FeatureBox>
              <FeatureBox>
                <FaBath style={{ fontSize: "16px" }} /> {item?.bathroom}
              </FeatureBox>
              <FeatureBox>
                <LuLandPlot style={{ fontSize: "16px" }} /> {item?.square_feet}
              </FeatureBox>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginTop: "10px",
                marginBottom: "15px",
                gap: "8px",
                color: "text.secondary",
                fontSize: "14px",
              }}
            >
              <FaLocationDot style={{ color: "#C10E14" }} />
              <Typography noWrap variant="body2">
                {item?.location}
              </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
            >
              <ContactButton
                variant="contained"
                color="primary"
                startIcon={<MdEmail />}
                fullWidth
                sx={{ bgcolor: "#C10E14" }}
                onClick={() => navigate(ROUTES.CONTACT_US)}
              >
                Email
              </ContactButton>
              <ContactButton
                variant="outlined"
                startIcon={<MdAddCall />}
                fullWidth
                sx={{ borderColor: "#C10E14", color: "#C10E14" }}
                onClick={() => navigate(ROUTES.CONTACT_US)}
              >
                Call
              </ContactButton>
            </Box>
          </CardContent>
        </PropertyCard>
      ))}
    </Box>
  );
};

export default CardComponent;
